<template>
  <div style="height:100%">
    <div id="main" class="mainCls">
      <div style="padding:20px; position:absolute; bottom:0px; text-align: center;">
        <p style="font-size:14px; line-height:20px;">目前只支持</p>
        <p style="font-size:14px; line-height:20px;">大乐透/双色球/福彩3D/七星彩/排列3/排列5/快乐8</p>
        <div style="padding:5px 80px;">
          <van-button @click="handleScan" class="btnCls" type="primary" round size="large">去体验</van-button>
        </div>
        <p style="font-size:14px; color:#fff; line-height:20px;">本产品仅为辅助工具，对验奖准确性不做保证中将情况请以官方开奖公告及兑奖结果为准</p>
      </div>
    </div>
  </div>

</template>
<script setup>
import { ref, reactive, onMounted, nextTick, toRaw } from 'vue'

const props = defineProps({
  scan: { type: Function, default: null },
})

const handleScan = () => {
  props.scan(1);
}

</script>
<style lang="less" scoped>
.btnCls {
  --van-button-primary-color: #000;
  --van-button-primary-background: var(--color-0008);

  font-weight: 600;
}

.mainCls {
  background-image: url(@/assets/img/czj.png);
  width: 100%;
  height: 100%;
  background-size: cover;
}
</style>